import './intro.scss'
import {KeyboardArrowDown} from "@material-ui/icons";
import { init } from 'ityped'
import { useEffect, useRef } from 'react';

export const Intro = () => {
  const textRef= useRef();

  useEffect(()=>{
    init(textRef.current, { showCursor: true, backDelay:1500, backspeed:40, strings: ['Developer', 'Programmer' ] })
  },[])

  return (
    <div className="intro" id="intro">
      <div className="left">
        <div className="imgContainer">
          <img src="https://user-images.githubusercontent.com/93377428/159475888-32cad2be-d22a-472d-bbec-b963d69e0e77.png" alt="" />
        </div>
      </div>
      <div className="right">
        <div className="wrapper">
          <h2>Hi There, I'm</h2>
          <h1>Akash Borate</h1>
          <h3>Full Stack <span ref={textRef}></span></h3>
        </div>
        <a href="#testimonials">
          <KeyboardArrowDown className= "arrow"/>
        </a>
      </div>
    </div>
  )
}
